/**
 * Feature access validation utilities for this module.
 *
 * The Settings module is gated on a single Boss Modernization feature:
 * `FEATURE_SETTINGS_MODERNIZATION` (131). Per-page access is handled by the
 * individual route guards (feature / security-group / privacy-policy).
 */

import { hasModuleAccess, getMissingFeatures } from '@m3-tech/boss-utils'
import { FEATURE_SETTINGS_MODERNIZATION } from '@m3-tech/boss-types'

/**
 * Required feature IDs for accessing this module
 */
export const REQUIRED_MODULE_FEATURES = [FEATURE_SETTINGS_MODERNIZATION] as const

/**
 * Validates if a user has all required features to access this module
 */
export function hasModuleFeatureAccess(userFeatures: number[]): boolean {
    return hasModuleAccess(userFeatures, REQUIRED_MODULE_FEATURES)
}

/**
 * Gets the list of missing feature IDs for this module
 */
export function getMissingModuleFeatures(userFeatures: number[]): number[] {
    return getMissingFeatures(userFeatures, REQUIRED_MODULE_FEATURES)
}
